import { Component } from 'react'

import * as h from 'h'

import styles from './styles.scss'

import { slugsToLinks, slugsToLabels } from 'config'

export default class LabelButtons extends Component {
  render () {
    const theme = this.props.theme
    const meta = this.props.data[0]
    const origin = this.props.data[1]
    const slug = this.props.data[2]
    let buttons = null

    if (meta[0] === 'Explore') { // For 'technologies' and 'startups' content
      const link = slugsToLinks[slug]
      const button1 = h.div({...h.ca(styles.labelButton), key: 1},
        h.l({to: link}, slugsToLabels[slug]))

      const secondLabel = meta[1].replace(/ /g, '+')
      const queryString = link + '?search=' + secondLabel +
        '&sort=relevance-asc'

      const button2 = h.div({...h.ca(styles.labelButton), key: 2},
        h.l({to: queryString}, meta[1]))

      buttons = [button1, button2]
    } else {
      const firstLink = origin.split('?')[0]
      const button1 = h.div({...h.ca(styles.labelButton), key: 1},
          h.l({to: firstLink}, meta[0]))
      const button2 = h.div({...h.ca(styles.labelButton), key: 2},
          h.l({to: origin}, meta[1]))
      buttons = [button1, button2]
    }

    return (
      h.div(h.ca(styles.meta, theme && theme.meta), buttons)
    )
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/components/LabelButtons/index.js